up.compiler('[close-modal-after-submit]', (element) => {

  element.addEventListener('click', function() {
    element.closest('form').submit()
    up.layer.dismiss()
  })

})
